// extracted by mini-css-extract-plugin
export default {"mediaQueryMobile":"810","mediaQueryTablet":"1024","mediaQueryDesktop":"1440","container":"index-module__container___F81Es","status":"index-module__status___A2TaS"};